const mEditionMapMessagesReplies = {
    mEditionMapMessagesReplies: {
      messages: {
        notAnswered: 'Sin Responder'
      },
  
      tooltip: {
        answer: 'Responder',
        comment: 'Comentar',
        like: 'Me Gusta',
        delete: 'Eliminar',
        noAnswers: 'Sin Respuestas',
        noComments: 'Sin Comentarios',
        seeAnswers: 'Ver Respuestas',
        seeComments: 'Ver Comentarios'
      }
    }
  }
  
  export default mEditionMapMessagesReplies
  